import { PaginatedResponse } from "./GlobalTypes";
import { Currency, IncomingPaymentDetails } from "./InvoiceTypes";
import { Chain } from "./WalletTypes";

export enum PaymentRequestStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PENDING_REVIEW = "PENDING_REVIEW",
  PAID = "PAID",
  REJECTED = "REJECTED",
}

export interface PaymentRequest {
  id: string;
  payer_name: string;
  currency: Currency;
  outgoing_currency: Currency;
  amount_atomic: number;
  amount: number;
  note: string;
  created_at: Date;
  paid_at?: Date;
  transaction_details: TransactionDetails;
  status: PaymentRequestStatus;
}

export interface TransactionDetails {
  paid_at: string;
  amount: number;
  commission_percent: number;
  commission_amount: number;
  outgoing_amount: number;
  tds: number;
  tds_amount: number;
  outgoing_amount_after_tds: number;
  outgoing_chain: Chain;
  outgoing_currency: Currency;
  explorer_link: string;
  price: number;
  is_indicative: boolean;
}

export interface PaymentRequestResponse
  extends PaginatedResponse<PaymentRequest> {}

export enum PayerRelationshipEnum {
  BUSINESS_EXPENSES_AND_INVESTMENTS = "BUSINESS_EXPENSES_AND_INVESTMENTS",
  ME = "ME",
  FRIENDS_AND_FAMILY = "FRIENDS_AND_FAMILY",
  MERCHANT_AND_CUSTOMER = "MERCHANT_AND_CUSTOMER",
  OTHER = "OTHER",
}

export enum PayerTypeEnum {
  INDIVIDUAL = "INDIVIDUAL",
  BUSINESS = "BUSINESS",
}

export interface PublicPaymentRequest {
  id?: string;
  payment_request_link: string;
  currency: Currency;
  amount_atomic_expected: string;
  amount: string;
  note?: string;
  payer_email?: string;
  payer_first_name?: string;
  payer_last_name?: string;
  payer_company_name?: string;
  payer_tax_id?: string;
  payer_address?: string;
  payer_relationship: PayerRelationshipEnum;
  payer_relationship_other?: string;
  payer_phone: string;
  payer_type: PayerTypeEnum;
  bank_details: IncomingPaymentDetails;
  beneficiary_name: string;
}
